import axios from 'axios';
import resolvePath from 'utils/resolvePath';
import { store } from 'store/store';
// Action
const GET_ISSUES = 'issues/getIssues';
const GET_ISSUES_REQUEST = 'issues/getIssuesRequest';
const GET_ISSUES_SUCCESS = 'issues/getIssuesSuccess';
const GET_ISSUES_FAILURE = 'issues/getIssuesFailure';
const CLEAR = 'favorites/clear';
// Action Creator
export const getIssuesRequest = () => {
    return {
        type: GET_ISSUES_REQUEST,
    };
};
export const getIssuesSuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: GET_ISSUES_SUCCESS,
    };
};
export const getIssuesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_ISSUES_FAILURE,
    };
};
export const getIssues = (authToken) => {
    const loadIssues = (dispatch) => {
        dispatch(getIssuesRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(`${resolvePath.api('billing/students/issues/available')}`, config)
            .then((response) => {
            dispatch(getIssuesSuccess(response.data));
        })
            .catch((error) => {
            dispatch(getIssuesFailure(error));
            throw error;
        });
    };
    loadIssues(store.dispatch);
    return {
        type: GET_ISSUES,
    };
};
export const clear = () => {
    return {
        type: CLEAR,
    };
};
const initialState = {
    gracing: false,
    issues: null,
    lang: null,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ISSUES_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_ISSUES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { gracing: action.payload.response.gracing, isFetching: false, issues: action.payload.response.issues, lang: action.payload.response.lang });
        }
        case GET_ISSUES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { issues: [] });
        }
        default: {
            return state;
        }
    }
};
